import { createConsumer } from '@rails/actioncable';

let consumer = null;

// Lazily created so pages that never use the live view pay no websocket cost
const getConsumer = () => {
  if (!consumer) {
    consumer = createConsumer('/cable');
  }
  return consumer;
};

export default getConsumer;
